/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const GLIDE_MS = 560
const GLIDE_DELAY_MS = 130

const meySwatchRow = () => ({
    expanded: false,

    init() {
        const observer = new ResizeObserver(() => this.doLayout())
        this.$nextTick(() => {
            if (this.$refs.swatchRow) observer.observe(this.$refs.swatchRow)
        })
    },

    doLayout() {
        const row = this.$refs.swatchRow
        if (!row || row.clientWidth === 0) return
        this.expanded = false
        row.classList.remove('overflow-x-auto', 'scrollbar-hide')
        row.removeAttribute('data-overflow')
        const swatchLis = Array.from(row.querySelectorAll('.swatch-li'))
        swatchLis.forEach(li => li.classList.remove('hidden'))
        const oldChip = row.querySelector('.swatch-chip-li')
        if (oldChip) oldChip.remove()
        if (row.scrollWidth <= row.clientWidth + 1) return
        const gap = parseFloat(window.getComputedStyle(row).columnGap) || 4
        const itemW = swatchLis[0] ? swatchLis[0].getBoundingClientRect().width : 28
        const chipLi = document.createElement('li')
        chipLi.className = 'swatch-chip-li flex-none mb-[3px]'
        const btn = document.createElement('button')
        btn.type = 'button'
        btn.className = 'text-tiny text-gray-500 whitespace-nowrap leading-none'
        btn.textContent = '+ ' + swatchLis.length
        chipLi.appendChild(btn)
        row.appendChild(chipLi)
        const chipW = chipLi.getBoundingClientRect().width
        let k = Math.max(1, Math.floor((row.clientWidth - chipW - gap) / (itemW + gap)))
        k = Math.min(k, swatchLis.length - 1)
        swatchLis.forEach((li, i) => { if (i >= k) li.classList.add('hidden') })
        btn.textContent = '+ ' + (swatchLis.length - k)
        const labelTpl = this.$el.dataset.labelShowAll || 'Show all %1 colors'
        btn.setAttribute('aria-label', labelTpl.replace('%1', swatchLis.length))
        btn.addEventListener('click', () => {
            this.expanded = true
            swatchLis.forEach(li => li.classList.remove('hidden'))
            chipLi.remove()
            row.classList.add('overflow-x-auto', 'scrollbar-hide')
            this.glideReveal(row)
        })
    },

    glideReveal(row) {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            this.updateFade()
            return
        }

        const from = row.scrollLeft
        const dist = (row.scrollWidth - row.clientWidth) - from
        if (dist <= 1) {
            this.updateFade()
            return
        }

        const easeOut = t => 1 - Math.pow(1 - t, 3)
        row.dataset.gliding = '1'
        row.removeAttribute('data-overflow')

        let t0 = null
        const step = (now) => {
            if (t0 === null) t0 = now
            const p = Math.min((now - t0) / GLIDE_MS, 1)
            row.scrollLeft = from + dist * easeOut(p)
            if (p < 1) {
                requestAnimationFrame(step)
            } else {
                delete row.dataset.gliding
                this.updateFade()
            }
        }
        setTimeout(() => requestAnimationFrame(step), GLIDE_DELAY_MS)
    },

    updateFade() {
        const row = this.$refs.swatchRow
        if (!row || row.dataset.gliding) return
        if (row.scrollWidth <= row.clientWidth + 1) { row.removeAttribute('data-overflow'); return }
        const atStart = row.scrollLeft <= 1
        const atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 1
        row.dataset.overflow = atStart ? 'right' : atEnd ? 'left' : 'both'
    }
})

export default meySwatchRow
